import { Action, ThunkAction } from '@reduxjs/toolkit';
import { dolan } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import { selectCurrentDescriptor } from '../../../editor/selectors';
import type { AppProjectEditorRootState } from '../../reducer';
import { revertCurrentDescriptor } from '../../../editor/actions';
import { showNotification } from '../../../notifications/actions';

export default function revertAppProjectIfInvalid(): ThunkAction<
  Promise<boolean>,
  AppProjectEditorRootState,
  unknown,
  Action<string>
> {
  return async (dispatch, getState) => {
    const state = getState();
    const currentDescriptor = selectCurrentDescriptor(state);
    const validation = dolan.safeParse(currentDescriptor);
    if (validation.success) {
      // Valid DOLAN => keep going
      return false;
    }
    // Invalid DOLAN => revert to the latest known remote state
    dispatch(revertCurrentDescriptor());
    dispatch(
      showNotification(
        'error',
        'Conflict: The app was modified by someone else but your unsaved changes could not be applied on top of them and have been discarded.',
      ),
    );
    return true;
  };
}
